enum EmployeeTitle {
    Unknown = 0,

    NursePractitioner = 1,
    Resident = 2,
    Intern = 3,
    OtherProfession = 4,
    NurseLegacy = 5,  // legacy title
    DoctorLegacy = 6, // legacy title
    Extern = 7,
    Student = 8,
    MedicalOfficeAssistant = 9,

    // Added in Roadmap 504 - User Type Assignment
    Acupuncturist = 10,
    Audiologist = 11,
    Biochemist = 12,
    Chiropractor = 13,
    CommunityAndSocialServiceWorker = 14,
    DentalHygienist = 15,
    DentalTechnician = 16,
    Dentist = 17,
    Denturist = 18,
    Denturologist = 19,
    Dietician = 20,
    Endodontist = 21,
    FamilyPhysician = 22,
    HearingAidAcoustician = 23,
    Kinesiologist = 24,
    LicensedPracticalNurse = 25,
    MassageTherapist = 26,
    MedicalImagingTechnologist = 27,
    MedicalTechnologist = 28,
    Midwife = 29,
    NaturopathicPhysician = 30,
    OccupationalTherapist = 31,
    Optician = 32,
    Optometrist = 33,
    Orthodontist = 34,
    Periodontist = 35,
    Pharmacist = 36,
    PhysicalTherapist = 37,
    Physiotherapist = 38,
    PodiatricSurgeon = 39,
    Podiatrist = 40,
    Provider = 41,
    Psychoeducator = 42,
    Psychologist = 43,
    RegisteredNurse = 44,
    RegisteredNurseClinician = 45,
    RegisteredNurseTechnician = 46,
    RespiratoryTherapist = 47,
    Sexologist = 48,
    SocialWorker = 49,
    Specialist = 50,
    SpeechLanguagePathologist = 51,
    SurgerySpecialist = 52,
    SpeechTherapist = 53,
    PhysiotherapyTechnologist = 54,
    Neuropsychologist = 55,
    MedicalArchivist = 56,
    MentalHealthSubstanceConsultant = 57,
    Criminologist = 58,

    NONE = 99
}

export { EmployeeTitle };
